'use client';

import { useTranslations } from 'next-intl';
import { useIsLogined } from '@/contexts/LoginContext';
import { useUnreadConnectionsCount } from '@/hooks/useUnreadConnectionsCount';
import { HeaderLink } from '../HeaderLink';

export const HeaderPersonalLinks = () => {
  const isLogined = useIsLogined();
  const t = useTranslations();
  const unreadConnectionsCount = useUnreadConnectionsCount();

  if (!isLogined) {
    return null;
  }

  return (
    <>
      <HeaderLink
        title={t('controls.header.my_products')}
        text={t('controls.header.my_products')}
        imageAlt={t('controls.header.my_products')}
        textClassName='hidden md:block'
        link='/my/products'
        iconLink='/assets/icons/type=cards.svg'
        count={0}
      />

      <HeaderLink
        title={t('chats.messages')}
        text={t('chats.messages')}
        imageAlt={t('chats.messages')}
        textClassName='hidden md:block'
        link='/my/chats'
        iconLink='/assets/icons/type_message-grey.svg'
        count={unreadConnectionsCount}
      />
    </>
  );
};
